// extracted by mini-css-extract-plugin
var _1 = "_eKK0GCa8iXG0ADMLKvz";
export { _1 as "title" }
